export default {
  trueAllDataDownloadExcel: {
    apiUrl: '/api/v1/intelligence_pc/detail/trueDataFeedback/history', // 真数下载地址
    translate: true,
  },
};
